import BalanceSellingFilters from './BalanceSellingFilters.view';

export default BalanceSellingFilters;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/BalanceSelling/BalanceSellingFilters/index.js